import useTrans from '@/hooks/useTrans';
import BreadcrumbComponent from '../Other/BreadCrumbComponent';
import MetaSeo from '../MetaSeo';
import styles from './hanaatm.module.css';
import about from '../../components/InvestGoldCourse/investgoldcourse.module.css';
import AppDownload from '../Common/AppDownload';
import { useState } from 'react';
import Device from '../Device';
import Slider from 'react-slick';

const HanaGoldATM = ({ title_seo, description, text_footer }) => {
  const trans = useTrans();
  const [typeGuide, setTypeGuide] = useState('app');

  const dataSeo = {
    title: title_seo || 'HanaGold ATM',
    description: description || 'HanaGold ATM - Cơ hội đầu tư hiện đại 4.0 HanaGold tự hào giới thiệu HanaGold ATM, là sự kết hợp giữa công nghệ hiện đại vào lĩnh vực kim hoàn truyền thống. Mang đến giải pháp đột phá giúp khách hàng dễ dàng tiếp cận và đầu tư vàng mọi lúc, mọi nơi.',
    url: 'https://hanagold.vn/hanagold-atm',
    image:
      'https://api.hanagold.vn/media-new/1732499894520-hanagold-atmpng.png',
  };

  let setting = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    customPaging: () => {
      return <span></span>;
    },
    nextArrow: (
      <div className='controls_s'>
        <img src='/assets/img/priority/outline_arrow_next.svg' alt='' />
      </div>
    ),
    prevArrow: (
      <div className='controls_s'>
        <img src='/assets/img/priority/outline_arrow_prev.svg' alt='' />
      </div>
    ),
    // responsive: [
    //   {
    //     breakpoint: 725,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //     },
    //   },
    //   {
    //     breakpoint: 1250,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 1,
    //     },
    //   },
    // ],
  };

  const listBenefit = [
    {
      icon: '/assets/img/hanagold-atm/benefit_1.png',
      title: trans.atm.benefit_title_1,
      description: trans.atm.benefit_description_1,
    },
    {
      icon: '/assets/img/hanagold-atm/benefit_2.png',
      title: trans.atm.benefit_title_2,
      description: trans.atm.benefit_description_2,
    },
    {
      icon: '/assets/img/hanagold-atm/benefit_3.png',
      title: trans.atm.benefit_title_3,
      description: trans.atm.benefit_description_3,
    },
    {
      icon: '/assets/img/hanagold-atm/benefit_4.png',
      title: trans.atm.benefit_title_4,
      description: trans.atm.benefit_description_4,
    },
    {
      icon: '/assets/img/hanagold-atm/benefit_5.png',
      title: trans.atm.benefit_title_5,
      description: trans.atm.benefit_description_5,
    },
  ];

  const listSecurity = [
    {
      title: trans.atm.title_code,
      description: trans.atm.infor_code,
    },
    {
      title: trans.atm.title_security,
      description: trans.atm.infor_security,
    },
    {
      title: trans.atm.title_monitor,
      description: trans.atm.infor_monitor,
    },
    {
      title: trans.atm.title_physical,
      description: trans.atm.infor_physical,
    },
  ];

  const listInfoProductCoin = [
    trans.atm.infor_coin_1,
    trans.atm.infor_coin_2,
    trans.atm.infor_coin_3,
  ];

  const listInfoProductRing = [
    trans.atm.infor_ring_1,
    trans.atm.infor_ring_2,
    trans.atm.infor_ring_3,
    trans.atm.infor_ring_4,
  ];

  const handleChangeTypeGuide = _type => {
    setTypeGuide(_type);
  };

  return (
    <>
      <MetaSeo {...dataSeo} />
      <section id='hana-atm'>
        <Device>
          {({ isMobile }) => (
            <>
              {!isMobile && (
                <>
                  <div
                    className={`${styles.container_hana_atm} ${styles.container_breadcrumb_hana_atm}`}
                  >
                    <BreadcrumbComponent
                      isHeader={false}
                      title={trans?.header?.hanagold_atm}
                      url='hanagold-atm'
                    />
                  </div>
                  <div className={styles.container_banner_hanagold_atm}>
                    <div className={styles.banner_hanagold_atm}>
                      <video autoPlay loop muted className={styles.banner_size}>
                        <source
                          src='/assets/img/hanagold-atm/video_banner_01.mp4'
                          type='video/mp4'
                        />
                      </video>
                      <div className={styles.overlay_banner_atm}></div>
                    </div>
                    <div
                      className={`${styles.container_hana_atm} ${styles.text_banner_hana_atm}`}
                      data-aos='fade-down'
                      data-aos-delay='400'
                    >
                      <h1>
                        <img
                          src='/assets/img/hanagold-atm/HanaGold ATM.svg'
                          className={styles.h1_hana_atm}
                          alt='h1'
                        />
                      </h1>
                      <h2>{trans.atm.banner_title}</h2>
                      <p>{trans.atm.banner_description}</p>
                    </div>
                  </div>
                  <div className={styles.bg_benefit_hana_atm}>
                    <div className={styles.container_hana_atm}>
                      <h2
                        className={styles.benefit_hana_atm_title}
                        data-aos='fade-up'
                        data-aos-delay='600'
                      >
                        {trans.atm.benefit_title}
                        <img
                          src='/assets/img/hanagold-atm/HanaGold ATM.svg'
                          className={styles.h1_hana_atm}
                          alt='h1'
                        />
                      </h2>
                      <div
                        className={styles.container_benefit_hana_atm}
                        data-aos='fade-down'
                        data-aos-delay='600'
                      >
                        <div>
                          {listBenefit?.slice(0, 1).map(e => {
                            return (
                              <div
                                className={`${styles.benefit_hana_atm_item} ${styles.first_benefit}`}
                              >
                                <img src={e?.icon} alt='first-benefit' />
                                <p>{e?.title}</p>
                                <a>{e?.description}</a>
                              </div>
                            );
                          })}
                        </div>
                        <div className={styles.container_other_benefit}>
                          {listBenefit?.slice(1, 3).map(e => {
                            return (
                              <div
                                className={`${styles.benefit_hana_atm_item} ${styles.other_benefit}`}
                              >
                                <img src={e?.icon} alt='other-benefit' />
                                <div className={styles.text_benefit}>
                                  <p>{e?.title}</p>
                                  <a>{e?.description}</a>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                        <div className={styles.container_other_benefit}>
                          {listBenefit?.slice(3, 5).map(e => {
                            return (
                              <div
                                className={`${styles.benefit_hana_atm_item} ${styles.other_benefit}`}
                              >
                                <img src={e?.icon} alt='other-benefit' />
                                <div className={styles.text_benefit}>
                                  <p>{e?.title}</p>
                                  <a>{e?.description}</a>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.bg_infor_step}>
                    <h2 data-aos='fade-left' data-aos-delay='600'>
                      {trans.atm.infor_atm}
                    </h2>
                    <div
                      className={`${styles.container_hana_atm} ${styles.container_step_hana}`}
                      data-aos='fade-right'
                      data-aos-delay='600'
                    >
                      <div className={styles.step_part_left}>
                        <div className={styles.step_1}>
                          <div className={styles.step_text}>
                            <p className={styles.step_title}>
                              {trans.atm.title_dimension}
                            </p>
                            <p className={styles.step_desc}>
                              {trans.atm.infor_dimension}
                            </p>
                          </div>
                          <div className={styles.step_images_1}>
                            <img
                              className={styles.img_step_1}
                              src='/assets/img/hanagold-atm/line_1.png'
                              alt='line_1'
                            />
                          </div>
                        </div>
                        <div className={styles.step_2}>
                          <div className={styles.step_text}>
                            <p className={styles.step_title}>
                              {trans.atm.title_product}
                            </p>
                            <p className={styles.step_desc}>
                              {trans.atm.infor_product}
                            </p>
                          </div>
                          <div className={styles.step_images_2}>
                            <img
                              className={styles.img_step_2}
                              src='/assets/img/hanagold-atm/line_2.png'
                              alt='line_2'
                            />
                          </div>
                        </div>
                        <div className={styles.step_3}>
                          <div className={styles.step_text}>
                            <p className={styles.step_title}>
                              {trans.atm.title_shopping}
                            </p>
                            <p className={styles.step_desc}>
                              {trans.atm.infor_shopping}
                            </p>
                          </div>
                          <div className={styles.step_images_2}>
                            <img
                              className={styles.img_step_3}
                              src='/assets/img/hanagold-atm/line_3.png'
                              alt='line_3'
                            />
                          </div>
                        </div>
                      </div>
                      <div className={styles.step_part_right}>
                        <div className={styles.step_4}>
                          <div className={styles.step_images_4}>
                            <img
                              src='/assets/img/hanagold-atm/line_4.png'
                              className={styles.img_step_1}
                              alt='line_4'
                            />
                          </div>
                          <div className={styles.step_text}>
                            <p className={styles.step_title}>
                              {trans.atm.title_payment}
                            </p>
                            <p className={styles.step_desc}>
                              {trans.atm.infor_payment}
                            </p>
                          </div>
                        </div>
                        <div className={styles.step_5}>
                          <div className={styles.step_images_5}>
                            <img
                              src='/assets/img/hanagold-atm/line_56.png'
                              className={styles.img_step_5}
                              alt='line_5'
                            />
                          </div>
                          <div className={styles.step_text}>
                            <p className={styles.step_title}>
                              {trans.atm.title_smart}
                            </p>
                            <p className={styles.step_desc}>
                              {trans.atm.infor_smart}
                            </p>
                          </div>
                        </div>
                        <div className={styles.step_6}>
                          <div className={styles.step_images_5}>
                            <img
                              src='/assets/img/hanagold-atm/line_56.png'
                              className={styles.img_step_5}
                              alt='line_5'
                            />
                          </div>
                          <div className={styles.step_text}>
                            <p className={styles.step_title}>
                              {trans.atm.title_app}
                            </p>
                            <p className={styles.step_desc}>
                              {trans.atm.infor_app}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.bg_security}>
                    <div
                      className={`${styles.container_hana_atm} ${styles.container_security}`}
                    >
                      <div
                        className={styles.icon_security}
                        data-aos='fade-up'
                        data-aos-delay='600'
                      >
                        <img
                          src='/assets/img/hanagold-atm/icon_security.svg'
                          alt='icon-security'
                        />
                      </div>
                      <div
                        className={styles.list_security}
                        data-aos='fade-down'
                        data-aos-delay='600'
                      >
                        {listSecurity.map((_se, _indexSe) => {
                          return (
                            <div className={styles.item_security}>
                              <h4>{_se.title}</h4>
                              <p>{_se.description}</p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className={styles.bg_product}>
                    <h2 data-aos='fade-right' data-aos-delay='600'>
                      {trans.atm.title_gold_product}
                    </h2>
                    <div
                      className={styles.list_product}
                      data-aos='fade-left'
                      data-aos-delay='600'
                    >
                      <div className={styles.container_product}>
                        <div className={styles.item_product}>
                          <img
                            src='/assets/img/hanagold-atm/coin.png'
                            alt='product-1'
                          />
                          <h4>{trans.atm.title_coin}</h4>
                          <div className={styles.list_infor_coin}>
                            {listInfoProductCoin.map((_coin, _indexCoin) => {
                              return (
                                <p>
                                  <span>•</span> {_coin}
                                </p>
                              );
                            })}
                          </div>
                        </div>
                        <div className={styles.item_product}>
                          <img
                            src='/assets/img/hanagold-atm/ring.png'
                            alt='product-1'
                          />
                          <h4>{trans.atm.title_ring}</h4>
                          <div className={styles.list_infor_coin}>
                            <p>{listInfoProductRing[0]}</p>
                            <div>
                              {listInfoProductRing
                                .slice(1, 4)
                                .map((_coin, _indexCoin) => {
                                  return (
                                    <p>
                                      <span>•</span> {_coin}
                                    </p>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.bg_hana_atm_guides}>
                    <h2 data-aos='fade-up' data-aos-delay='600'>
                      {trans.atm.title_guides}
                    </h2>
                    <div
                      className={styles.container_hana_atm}
                      data-aos='fade-down'
                      data-aos-delay='600'
                    >
                      <div className={styles.container_guides}>
                        <div className={styles.block_select_guides}>
                          <p
                            onClick={() => handleChangeTypeGuide('app')}
                            className={`${
                              typeGuide === 'app' ? `${styles.active}` : ''
                            }`}
                          >
                            App HanaGold
                          </p>
                          <p
                            onClick={() => handleChangeTypeGuide('atm')}
                            className={`${
                              typeGuide === 'atm' ? `${styles.active}` : ''
                            }`}
                          >
                            HanaGold ATM
                          </p>
                        </div>
                        <div className={styles.guide_steps}>
                          <div className={styles.guide_step_1}>
                            <div className={styles.guide_step_text}>
                              <h4>{trans.atm.title_step_1}</h4>
                              <p>
                                {typeGuide === 'app'
                                  ? trans.atm.infor_step_app_1
                                  : trans.atm.infor_step_atm_1}
                              </p>
                            </div>
                            <div className={styles.guide_step_img}>
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='91'
                                height='129'
                                viewBox='0 0 91 129'
                                fill='none'
                              >
                                <path
                                  d='M0.666667 6C0.666667 8.94552 3.05448 11.3333 6 11.3333C8.94552 11.3333 11.3333 8.94552 11.3333 6C11.3333 3.05448 8.94552 0.666667 6 0.666667C3.05448 0.666667 0.666667 3.05448 0.666667 6ZM6 121H5V122H6V121ZM90.7071 121.707C91.0976 121.317 91.0976 120.683 90.7071 120.293L84.3431 113.929C83.9526 113.538 83.3195 113.538 82.9289 113.929C82.5384 114.319 82.5384 114.953 82.9289 115.343L88.5858 121L82.9289 126.657C82.5384 127.047 82.5384 127.681 82.9289 128.071C83.3195 128.462 83.9526 128.462 84.3431 128.071L90.7071 121.707ZM5 6V10.1071H7V6H5ZM5 18.3214V26.5357H7V18.3214H5ZM5 34.75V42.9643H7V34.75H5ZM5 51.1786V59.3929H7V51.1786H5ZM5 67.6071V75.8214H7V67.6071H5ZM5 84.0357V92.25H7V84.0357H5ZM5 100.464V108.679H7V100.464H5ZM5 116.893V121H7V116.893H5ZM6 122H10.2V120H6V122ZM18.6 122H27V120H18.6V122ZM35.4 122H43.8V120H35.4V122ZM52.2 122H60.6V120H52.2V122ZM69 122H77.4V120H69V122ZM85.8 122H90V120H85.8V122Z'
                                  fill='#1A1A1A'
                                />
                              </svg>
                            </div>
                          </div>
                          <div className={styles.guide_step_2}>
                            <div className={styles.guide_step_img}>
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='91'
                                height='129'
                                viewBox='0 0 91 129'
                                fill='none'
                              >
                                <path
                                  d='M0.666667 6C0.666667 8.94552 3.05448 11.3333 6 11.3333C8.94552 11.3333 11.3333 8.94552 11.3333 6C11.3333 3.05448 8.94552 0.666667 6 0.666667C3.05448 0.666667 0.666667 3.05448 0.666667 6ZM6 121H5V122H6V121ZM90.7071 121.707C91.0976 121.317 91.0976 120.683 90.7071 120.293L84.3431 113.929C83.9526 113.538 83.3195 113.538 82.9289 113.929C82.5384 114.319 82.5384 114.953 82.9289 115.343L88.5858 121L82.9289 126.657C82.5384 127.047 82.5384 127.681 82.9289 128.071C83.3195 128.462 83.9526 128.462 84.3431 128.071L90.7071 121.707ZM5 6V10.1071H7V6H5ZM5 18.3214V26.5357H7V18.3214H5ZM5 34.75V42.9643H7V34.75H5ZM5 51.1786V59.3929H7V51.1786H5ZM5 67.6071V75.8214H7V67.6071H5ZM5 84.0357V92.25H7V84.0357H5ZM5 100.464V108.679H7V100.464H5ZM5 116.893V121H7V116.893H5ZM6 122H10.2V120H6V122ZM18.6 122H27V120H18.6V122ZM35.4 122H43.8V120H35.4V122ZM52.2 122H60.6V120H52.2V122ZM69 122H77.4V120H69V122ZM85.8 122H90V120H85.8V122Z'
                                  fill='#1A1A1A'
                                />
                              </svg>
                            </div>
                            <div className={styles.guide_step_text}>
                              <h4>{trans.atm.title_step_2}</h4>
                              <p>
                                {typeGuide === 'app'
                                  ? trans.atm.infor_step_app_2
                                  : trans.atm.infor_step_atm_2}
                              </p>
                            </div>
                          </div>
                          <div className={styles.guide_step_3}>
                            <div className={styles.guide_step_text}>
                              <h4>{trans.atm.title_step_3}</h4>
                              <p>
                                {typeGuide === 'app'
                                  ? trans.atm.infor_step_app_3
                                  : trans.atm.infor_step_atm_3}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <AppDownload is_home={false} />
                  <div className={about.section_8}>
                    <div className={about.section_8_bg}>
                      <div
                        className={about.container_invest}
                        data-aos='fade-left'
                        data-aos-delay='400'
                      >
                        <div className={about.section_8_content}>
                          <p className={about.section_8_content_title}>
                            {trans?.business_solutions?.about_title}
                          </p>
                          <div
                            className={`${about.section_8_content_text} ${about.use_pc}`}
                          >
                            <p>
                              {trans?.business_solutions?.about_description_3}
                            </p>
                            <p>
                              {trans?.business_solutions?.about_description_4}
                            </p>
                            <p>
                              {trans?.business_solutions?.about_description_5}
                            </p>
                          </div>
                          <div
                            className={`${about.section_8_content_text} ${about.use_sp}`}
                          >
                            <p>
                              {trans?.business_solutions?.about_description_1}
                            </p>
                            <p>
                              {trans?.business_solutions?.about_description_2}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {isMobile && (
                <>
                  <div className={`${styles.container_hana_atm}`}>
                    <div className={`${styles.hanagold_atm_breadcrumb}`}>
                      <BreadcrumbComponent title={'HanaGold ATM'} url='hanagold-atm'/>
                    </div>
                  </div>
                  <div className={styles.bg_banner_hana_atm_sp}>
                    <div className={styles.container_hana_atm}>
                      <h2 className={styles.banner_title_1_sp}>HanaGold ATM</h2>
                      <p className={styles.banner_title_2_sp}>
                        {trans.atm.banner_title}
                      </p>
                      <p className={styles.banner_description_sp}>
                        {trans.atm.banner_description}
                      </p>
                    </div>
                  </div>
                  <div className={styles.bg_benefit_sp_hana_atm}>
                    <div className={styles.container_hana_atm}>
                      <h2
                        className={styles.benefit_sp_hana_atm_title}
                        data-aos='fade-up'
                        data-aos-delay='600'
                      >
                        {trans.atm.benefit_title}
                        <br />
                        <span>HanaGold ATM</span>
                      </h2>
                      <div
                        className={styles.container_benefit_hana_atm}
                        data-aos='fade-down'
                        data-aos-delay='600'
                      >
                        <div>
                          {listBenefit?.slice(0, 1).map(e => {
                            return (
                              <div
                                className={`${styles.benefit_hana_atm_item} ${styles.first_benefit}`}
                              >
                                <div
                                  className={
                                    styles.container_image_first_benefit
                                  }
                                >
                                  <img src={e?.icon} alt='first-benefit' />
                                </div>
                                <p>{e?.title}</p>
                                <a>{e?.description}</a>
                              </div>
                            );
                          })}
                        </div>
                        <div className={styles.container_other_benefit}>
                          {listBenefit?.slice(1, 3).map(e => {
                            return (
                              <div
                                className={`${styles.benefit_hana_atm_item} ${styles.other_benefit}`}
                              >
                                <img src={e?.icon} alt='other-benefit' />
                                <div className={styles.text_benefit}>
                                  <p>{e?.title}</p>
                                  <a>{e?.description}</a>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                        <div className={styles.container_other_benefit}>
                          {listBenefit?.slice(3, 5).map(e => {
                            return (
                              <div
                                className={`${styles.benefit_hana_atm_item} ${styles.other_benefit}`}
                              >
                                <img src={e?.icon} alt='other-benefit' />
                                <div className={styles.text_benefit}>
                                  <p>{e?.title}</p>
                                  <a>{e?.description}</a>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.bg_infor_step_sp}>
                    <div className={styles.container_hana_atm}>
                      <h2 data-aos='fade-up' data-aos-delay='600'>
                        {trans.atm.infor_atm}
                      </h2>
                      <div className={styles.list_infor_step}>
                        <div
                          className={styles.list_left}
                          data-aos='fade-left'
                          data-aos-delay='600'
                        >
                          <div
                            className={`${styles.step_text_sp} ${styles.step_text_1}`}
                          >
                            <p className={styles.step_title}>
                              {trans.atm.title_dimension}
                            </p>
                            <p className={styles.step_desc}>
                              {trans.atm.infor_dimension}
                            </p>
                          </div>
                          <div
                            className={`${styles.step_text_sp} ${styles.step_text_1}`}
                          >
                            <p className={styles.step_title}>
                              {trans.atm.title_product}
                            </p>
                            <p className={styles.step_desc}>
                              {trans.atm.infor_product}
                            </p>
                          </div>
                          <div
                            className={`${styles.step_text_sp} ${styles.step_text_1}`}
                          >
                            <p className={styles.step_title}>
                              {trans.atm.title_shopping}
                            </p>
                            <p className={styles.step_desc}>
                              {trans.atm.infor_shopping}
                            </p>
                          </div>
                        </div>
                        <div
                          className={styles.line_infor_step}
                          data-aos='fade-down'
                          data-aos-delay='600'
                        >
                          <img
                            src='/assets/img/hanagold-atm/line_infor_step.svg'
                            alt='list-infor-step'
                          />
                        </div>
                        <div
                          className={styles.list_right}
                          data-aos='fade-right'
                          data-aos-delay='600'
                        >
                          <div
                            className={`${styles.step_text_sp} ${styles.step_text_1}`}
                          >
                            <p className={styles.step_title}>
                              {trans.atm.title_payment}
                            </p>
                            <p className={styles.step_desc}>
                              {trans.atm.infor_payment}
                            </p>
                          </div>
                          <div
                            className={`${styles.step_text_sp} ${styles.step_text_1}`}
                          >
                            <p className={styles.step_title}>
                              {trans.atm.title_smart}
                            </p>
                            <p className={styles.step_desc}>
                              {trans.atm.infor_smart}
                            </p>
                          </div>
                          <div
                            className={`${styles.step_text_sp} ${styles.step_text_1}`}
                          >
                            <p className={styles.step_title}>
                              {trans.atm.title_app}
                            </p>
                            <p className={styles.step_desc}>
                              {trans.atm.infor_app}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.bg_security_sp}>
                    <div className={styles.container_hana_atm}>
                      <div
                        className={styles.list_security_left}
                        data-aos='fade-right'
                        data-aos-delay='600'
                      >
                        <div
                          className={`${styles.item_security_text} ${styles.item_security_1}`}
                        >
                          <h4>{trans.atm.title_code}</h4>
                          <p>{trans.atm.infor_code}</p>
                        </div>
                        <div className={styles.item_security_img}>
                          <img src='/assets/img/hanagold-atm/line_security_left.png' />
                        </div>
                        <div
                          className={`${styles.item_security_text} ${styles.item_security_2}`}
                        >
                          <h4>{trans.atm.title_security}</h4>
                          <p>{trans.atm.infor_security}</p>
                        </div>
                      </div>
                      <div
                        className={styles.list_security_right}
                        data-aos='fade-left'
                        data-aos-delay='600'
                      >
                        <div
                          className={`${styles.item_security_text} ${styles.item_security_3}`}
                        >
                          <h4>{trans.atm.title_monitor}</h4>
                          <p>{trans.atm.infor_monitor}</p>
                        </div>
                        <div className={styles.item_security_img}>
                          <img src='/assets/img/hanagold-atm/line_security_right.png' />
                        </div>
                        <div
                          className={`${styles.item_security_text} ${styles.item_security_4}`}
                        >
                          <h4>{trans.atm.title_physical}</h4>
                          <p>{trans.atm.infor_physical}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.bg_gold_product}>
                    <h2 data-aos='fade-up' data-aos-delay='600'>
                      {trans.atm.title_gold_product}
                    </h2>
                    <div
                      className={`${styles.list_gold_product_sp} list_gold_product`}
                      data-aos='fade-down'
                      data-aos-delay='600'
                    >
                      <Slider {...setting}>
                        <div className={styles.item_product}>
                          <img
                            src='/assets/img/hanagold-atm/coin.png'
                            alt='product-1'
                          />
                          <h4>{trans.atm.title_coin}</h4>
                          <div className={styles.list_infor_coin}>
                            {listInfoProductCoin.map((_coin, _indexCoin) => {
                              return (
                                <p key={_indexCoin}>
                                  <span>•</span> {_coin}
                                </p>
                              );
                            })}
                          </div>
                        </div>
                        <div
                          className={`${styles.item_product} ${styles.ring_gold}`}
                        >
                          <img
                            src='/assets/img/hanagold-atm/ring.png'
                            alt='product-1'
                          />
                          <h4>{trans.atm.title_ring}</h4>
                          <div className={`${styles.list_infor_coin}`}>
                            <p>{listInfoProductRing[0]}</p>
                            <div>
                              {listInfoProductRing
                                .slice(1, 4)
                                .map((_coin, _indexCoin) => {
                                  return (
                                    <p key={_indexCoin}>
                                      <span>•</span> {_coin}
                                    </p>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      </Slider>
                    </div>
                  </div>
                  <div className={styles.bg_guides_sp}>
                    <div className={styles.container_hana_atm}>
                      <h2 data-aos='fade-up' data-aos-delay='600'>
                        {trans.atm.title_guides}
                      </h2>
                      <div
                        className={styles.select_type_guides}
                        data-aos='fade-down'
                        data-aos-delay='600'
                      >
                        <div className={styles.box_select_type_guides}>
                          <p
                            onClick={() => handleChangeTypeGuide('app')}
                            className={`${
                              typeGuide === 'app' ? `${styles.active}` : ''
                            }`}
                          >
                            App HanaGold
                          </p>
                          <p
                            onClick={() => handleChangeTypeGuide('atm')}
                            className={`${
                              typeGuide === 'atm' ? `${styles.active}` : ''
                            }`}
                          >
                            HanaGold ATM
                          </p>
                        </div>
                        <div className={styles.list_guides_step_mb}>
                          <div className={styles.item_guides_mb}>
                            <h4>{trans.atm.title_step_1}</h4>
                            <p>
                              {typeGuide === 'app'
                                ? trans.atm.infor_step_app_1
                                : trans.atm.infor_step_atm_1}
                            </p>
                          </div>
                          <div className={styles.item_guides_mb}>
                            <h4>{trans.atm.title_step_2}</h4>
                            <p>
                              {typeGuide === 'app'
                                ? trans.atm.infor_step_app_2
                                : trans.atm.infor_step_atm_2}
                            </p>
                          </div>
                          <div className={styles.item_guides_mb_3}>
                            <h4>{trans.atm.title_step_3}</h4>
                            <p>
                              {typeGuide === 'app'
                                ? trans.atm.infor_step_app_3
                                : trans.atm.infor_step_atm_3}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <AppDownload is_home={false} />
                  <div className={about.section_8}>
                    <div className={about.section_8_bg}>
                      <div
                        className={about.container_invest}
                        data-aos='fade-left'
                        data-aos-delay='400'
                      >
                        <div className={about.section_8_content}>
                          <p className={about.section_8_content_title}>
                            {trans?.business_solutions?.about_title}
                          </p>
                          <div
                            className={`${about.section_8_content_text} ${about.use_pc}`}
                          >
                            <p>
                              {trans?.business_solutions?.about_description_3}
                            </p>
                            <p>
                              {trans?.business_solutions?.about_description_4}
                            </p>
                            <p>
                              {trans?.business_solutions?.about_description_5}
                            </p>
                          </div>
                          <div
                            className={`${about.section_8_content_text} ${about.use_sp}`}
                          >
                            <p>
                              {trans?.business_solutions?.about_description_1}
                            </p>
                            <p>
                              {trans?.business_solutions?.about_description_2}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </Device>
      </section>
    </>
  );
};

export default HanaGoldATM;
